export default __webpack_public_path__ + "ecdc620004c2e5031563dcab8706f05a.png";